import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ROUTES } from './api-routes';
import {
  FileDownload,
  FileResponse,
  FilesInExtractionResponse,
  FullFileDataResponse,
  ViewFile
} from '../interfaces/file-upload-interfaces';
import { Observable } from 'rxjs';
import { DEFAULT_JSON_HEADERS } from './headers.config';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  constructor(private http: HttpClient) { }

  upload(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post<FileResponse>(
      `${API_ROUTES.FILES.UPLOAD}`,
      formData,
      { reportProgress: true, observe: 'events' }
    );
  }

  downloadFile(file_id: string): Observable<any> {
    return this.http.get<FileDownload>(
      `${API_ROUTES.FILES.DOWNLOAD}${file_id}`,
    );
  }

  viewPdfFile(file_id: string): Observable<ArrayBuffer> {
    return this.http.get(
      `${API_ROUTES.FILES.VIEW_PDF}${file_id}`,
      { responseType: 'arraybuffer' }
    );
  }

  getPdfUrl(file_id: string): Observable<ViewFile> {
    return this.http.get<ViewFile>(
      `${API_ROUTES.FILES.PDF_URL}${file_id}`,
    );
  }

  deleteFile(file_id: string): Observable<any> {
    return this.http.delete<any>(
      `${API_ROUTES.FILES.DEFAULT}${file_id}`,
    );
  }

  // Admin method
  getFileFullData(file_id: string): Observable<FullFileDataResponse> {
    return this.http.get<FullFileDataResponse>(
      `${API_ROUTES.FILES.FULL_DATA}/${file_id}`,
    );
  }

  //
  getFileIconSrcByFileType(fileExtension?: string) {
    var fileIconSrc: string = 'assets/icons/files/unknown-file.svg';
    if (fileExtension === 'pdf') {
      fileIconSrc = 'assets/icons/files/pdf.svg';
    }
    else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
      fileIconSrc = 'assets/icons/files/excel.svg';
    }
    return fileIconSrc;
  }

  checkExtractionInProgress(company_id: string): Observable<FilesInExtractionResponse> {
    return this.http.get<FilesInExtractionResponse>(
      `${API_ROUTES.FILES.FILES_IN_EXTRACTION_COUNT}/${company_id}`,
    );
  }

  checkExtractionInProgressElectricity(company_id: string): Observable<FilesInExtractionResponse> {
    return this.http.get<FilesInExtractionResponse>(
      `${API_ROUTES.FILES.ELECTRICITY_FILES_IN_EXTRACTION_COUNT}/${company_id}`,
    );
  }

  checkExtractionInProgressGas(company_id: string): Observable<FilesInExtractionResponse> {
    return this.http.get<FilesInExtractionResponse>(
      `${API_ROUTES.FILES.GAS_FILES_IN_EXTRACTION_COUNT}/${company_id}`,
    );
  }

  // Reupload email
  sendReuploadEmail(fileId: string): Observable<any> {
    return this.http.post<string>(
      `${API_ROUTES.FILES.REUPLOAD_EMAIL}/${fileId}`,
      {
        headers: DEFAULT_JSON_HEADERS,
        responseType: 'text' as 'json'
      }
    );
  }
}
